import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ClosePurpleIcon from "../../../../assets/icons/close-purple.svg";
import Loader from "../../../loader/Loader";
import { subscriptionsService } from "../../../../services";
import "./FreeSubscriptionCancelModal.less";

export type FreeSubscriptionCancelModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  creatorId: string;
};

const FreeSubscriptionCancelModal: React.FC<FreeSubscriptionCancelModalProps> = ({ onClose, onConfirm, isLoading, creatorId }) => {
  const { t } = useTranslation();
  const [remainingDays, setRemainingDays] = useState<number>(0);
  const [isLoadingData, setIsLoadingData] = useState<boolean>(true);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    if (creatorId) {
      setIsLoadingData(true);
      subscriptionsService
        .checkSubscriptionEligibility({ creatorId, type: null })
        .then((data) => {
          setRemainingDays(data.remainingDays || 60);
          setIsLoadingData(false);
        })
        .catch((error) => {
          console.error("Error checking eligibility:", error);
          setRemainingDays(60);
          setIsLoadingData(false);
        });
    }
  }, [creatorId]);

  const handleOverlayClick = () => {
    if (!isLoading) {
      onClose?.();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="free-subscription-cancel-modal-overlay" onClick={handleOverlayClick}>
      <div className="free-subscription-cancel-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="free-subscription-cancel-modal-scrollable">
          {isLoadingData ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "150px" }}>
              <Loader size="medium" />
            </div>
          ) : (
            <>
              <img src={ClosePurpleIcon} className="free-subscription-cancel-modal-icon" alt="Close" />

              <div className="free-subscription-cancel-section-title">{t("are-you-sure-cancel-subscription")}</div>

              <div className="free-subscription-cancel-description">{t("free-subscription-cancel-warning", { remainingDays })}</div>
            </>
          )}
        </div>

        <div className="free-subscription-cancel-modal-footer">
          <button className="free-subscription-cancel-modal-confirm-button" onClick={onConfirm} disabled={isLoading || isLoadingData}>
            {t("cancel-subscription")}
          </button>
          <button className="free-subscription-cancel-modal-cancel-button" onClick={onClose} disabled={isLoading || isLoadingData}>
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FreeSubscriptionCancelModal;
